'use client';
import { useState } from 'react';

/* TODO: при повторной необходимости использовать - обобщить и вынести в hooks */ var useIMESessionGuard = function() {
    var guard = function guard(handler) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (IMESession) {
                return;
            }
            return handler.apply(void 0, [].concat(args));
        };
    };
    var _useState = useState(false), IMESession = _useState[0], setIMESession = _useState[1];
    var startIMESession = function() {
        return setIMESession(true);
    };
    var endIMESession = function() {
        return setIMESession(false);
    };
    return [
        guard,
        startIMESession,
        endIMESession
    ];
};

export { useIMESessionGuard };
